var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',{staticClass:"sample-card",attrs:{"cols":"7"}},[_c('v-card',{staticClass:"pa-2"},[_c('v-container',{staticClass:"pa-7"},[_c('JobNewHeaderSample'),[_c('JobNewDataSample'),_c('JobNewMainSample')]],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }